<template>
    <div>
        <el-date-picker
            v-if="mode == 'edit'"
            v-model="tmpValue"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="date"
            :format="formatDate.display"
            :placeholder="placeholder"
            :picker-options="{ ...pickerOptions, firstDayOfWeek: 1 }"
            :clearable="clearable"
            :disabled="disabled"
            :data-bot="dataBot"
            @change="update"
        >
        </el-date-picker>
        <p v-else>
            {{ date }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
            default: '',
        },
        value: {
            type: [Number, String, Date],
            required: false,
            default: '',
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        canBeInThePast: {
            type: Boolean,
            required: false,
            default: true,
        },
        pastStart: {
            type: String,
            required: false,
            default: '',
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        options: {
            type: Object,
            required: false,
            default: () => {},
        },
        format: {
            type: String,
            required: false,
            default: 'dmy',
        },
        clearable: {
            type: Boolean,
            required: false,
            default: true,
        },
        dataBot: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            tmpValue: '',
            formats: {
                dmy: {
                    display: 'dd/MM/yyyy',
                    value: 'yyyy-MM-dd HH:mm:ss',
                },
                mdy: {
                    display: 'MM/dd/yyyy',
                    value: 'yyyy-dd-MM HH:mm:ss',
                },
            },
        };
    },
    computed: {
        formatDate() {
            return this.formats[this.format];
        },
        date() {
            if (this.tmpValue) {
                return moment(this.tmpValue).format('LL');
            } else {
                return this.$l10n.__('N/C');
            }
        },
        pickerOptions() {
            if (!this.canBeInThePast) {
                const pastStart = this.pastStart;
                return {
                    ...this.options,
                    disabledDate: function (time) {
                        if (pastStart && pastStart != '') {
                            const datePastStart = new Date(pastStart).setHours(0, 0, 0, 0);
                            return time.getTime() < datePastStart;
                        } else {
                            return time.getTime() < new Date().setHours(0, 0, 0, 0);
                        }
                    },
                };
            }
            return this.options;
        },
    },
    watch: {
        value: function (newVal) {
            this.tmpValue = newVal;
        },
    },
    created() {
        this.tmpValue = this.value;
    },
    methods: {
        update(newVal) {
            this.$emit('input', newVal);
        },
    },
};
</script>
